import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from '../DetalleDeCompraComponent.module.css'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black'
};
const ModalMensajeComponent = (props) => {

    const { titleModal, bodyModal } = props

    
    const [openModal, setOpenModal] = React.useState(true);
    const handleOpenModal = () => {
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false)
        props.setOpenModal.setOpenModal()
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }} className='text-danger'>
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black" , textAlign: 'justify'}}>
                            <center>{bodyModal}</center>
                        </Typography>
                        <Typography sx={{ mt: 5 }}>                       
                            <button className={`btn ${estilos.botonModal}`} onClick={() => handleCloseModal()}>Aceptar</button>                        
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalMensajeComponent)
